import React, { useState, useEffect, useRef } from "react";
import { AppBar, Toolbar, Button, Avatar, Tooltip } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import fdlogo from "./../../assets/img/fd-white-logo.png";
import { withRouter } from "../../utils/withRouter";
import ModalPopup from "f1-modal-react";
import "./header.scss";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { get, post } from "../../api/api";
import { Link } from "react-router-dom";
import axios from "axios";
// import { useHistory } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useNavigate } from "react-router-dom";
import { ApiUrls } from "../../api/baseURL";
import MenuIcon from '@mui/icons-material/Menu';
import { FaBars, FaHome, FaLock, FaMoneyBill, FaUser } from "react-icons/fa";
import SyncIcon from '@mui/icons-material/Sync';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import InventoryIcon from '@mui/icons-material/Inventory';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import barcodeIcon from '../../assets/img/icon1.svg';
import useOnlineStatus from "../../useOnlineStatus";
import StorageIcon from '@mui/icons-material/Storage';
import packageJson from "../../../package.json";
import { addToCollection, deleteDb } from "../../offlineManager/localbase";
import IdleTimer from 'react-idle-timer';
import { featureHasAccess, getOfflineFeatures, getPhysicalInventoryCheckOffline, getPreviousQuantity } from "../../utils/utils";
import { metaDataConstants } from "../../utils/Constants/constants-en";
import Loader from "../loader/loader";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
const Header = (props) => {

  let idleTimer = useRef();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [userEmail, setUserEmail] = useState("");
  const isFirstLogin = localStorage.getItem('isFirstLogin') === 'true'
  const [userName, setUserName] = useState("");
  const isOnline = useOnlineStatus();
  const [activateLoader, setActivateLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [timer, setTimer] = useState({ minutes: 29, seconds: 59 });
  const [notificationData, setNotificationData] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [stateAnchor, setStateAnchor] = useState({ left: false });
  const [showAppVersionModal, setShowAppVersionModal] = useState(false);
  const moduleAccessLocal = localStorage.getItem('module_access')
  const moduleAccess = moduleAccessLocal != 'undefined' ? JSON.parse(moduleAccessLocal) : {};
  const featureAccess = JSON.parse(localStorage.getItem('feature'));
  const [drawerList, setDrawerList] = useState({
    right: false,
  });
  const store = useSelector(state => state);
  let timerInterval;

  useEffect(() => {
    const email = localStorage.getItem("email");
    const firstName = localStorage.getItem("firstName");
    const lastName = localStorage.getItem("lastName");
    setUserEmail(email);
    setUserName(firstName + ' ' + lastName);
  }, []);

  useEffect(() => {
    checkForTokenAndLogOutAutomatically();
  }, []);

  useEffect(() => {
    if (isOnline) {
      setActivateLoader(true);
      Promise.all([getAllNotification(), getRoleBasedFeature(), isFirstLogin ? getUpdatedVersion() : null]).then(() => {
        setActivateLoader(false);
      }).catch(() => {
        setActivateLoader(false);
      })

    } else {
      const NewResponseData = JSON.parse(localStorage.getItem('responseData'));
      const NewtotalCount = localStorage.getItem('totalCount');
      console.log(NewResponseData, "NewResponseData");
      setNotificationData(NewResponseData);
      setNotificationCount(NewtotalCount);
    }
  }, []);

  useEffect(() => {
    store.sync == 'SYNC_REQUESTED' && syncData();
  }, [store]);
  
  const checkForTokenAndLogOutAutomatically = () => {
    let id = setInterval(() => {
      const token = localStorage.getItem('tokenKey');
      //If no token then navigate to login page
      if (!token) {
        signOut()
      } else {
        getUpdatedVersion()
      }
    }, 15000)
  }
  const getUpdatedVersion = async () => {
    const payload = {
      key: "PWAAPP_VERSION_KEY"
    };

    const response = await post(ApiUrls().CONFIG_DATA_SEARCH, payload)
      .catch(function (error) {
        // Handle errors here
        console.error("Error:", error);
        if (error?.data == "User Access Token is invalid" || error?.data == "Token is invalid") {
          signOut();
        }
      });

    if (response?.status === 200) {
      if (packageJson.version != response?.data.result[0].value) {
        setShowAppVersionModal(true)
      }
    }
  };

  const clearCache = () => {
    if (caches) {
      // Service worker cache should be cleared with caches.delete()
      caches.keys().then((names) => {
        for (const name of names) {
          caches.delete(name);
        }
      });

      setShowAppVersionModal(false);
      // // delete browser cache and hard reload
      signOut()
      window.location.reload();

    } else {
      console.log("cache undefined");
    }
  };
  const getRoleBasedFeature = async () => {
    const payload = {
      UserId: localStorage.getItem("userID"),
      FeatureName: "INVENTORY_COUNT_SUMMARY",
    };
    const response = await post(ApiUrls().GET_ROLE_BASED_FEATUREACCESS, payload)
      .catch(function (error) {
        // Handle errors here
        console.error("Error:", error);
      });
    if (response?.status === 200) {
      const access = response?.data.result.filter((el) => el.featureTypeName == "Edit")
      if (access[0]?.featureTypeName == "Edit") {
        localStorage.setItem("permission", access[0]?.featureTypeName)
      }
    }
  };

  const getAllNotification = async () => {
    const payload = {
      userName: "test",
      tag: "WBC",
      IsActive: 1,
      pageSize: 5,
      pageNumber: 1,
      isRead: 0,
    };

    const response = await post(ApiUrls().GET_ALL_NOTIFICATION, payload)
      .catch(function (error) {
        // Handle errors here
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      const responseData = [];

      for (const element of response?.data.result) {
        const match = element.textBody.match(/>([^<]+)<\/a>/);
        // Check if a match is found
        if (match && match[1]) {
          element.textBody = match[1].trim();
        } else {
          console.log("No match found.");
        }
        responseData.push(element);
      }
      setNotificationData(responseData);
      setNotificationCount(response?.data.paging.totalCount);
      const NotificationData = JSON.stringify(responseData)
      localStorage.setItem('responseData', NotificationData)
      localStorage.setItem('totalCount', response?.data.paging.totalCount)
    }
  };
  async function handleHardReload(url) {
    await fetch(url, {
      headers: {
        Pragma: 'no-cache',
        Expires: '-1',
        'Cache-Control': 'no-cache',
      },
    });
    window.location.href = url;
    // This is to ensure reload with url's having '#'
    window.location.reload();
  }
  const signOut = () => {
    clearInterval(timerInterval);
    localStorage.clear();
    localStorage.removeItem("timer")
    deleteDb()
    props.navigate("/");
    // window.location.reload(true);
    handleHardReload(window.location.href)
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleAddDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setStateAnchor({ ...stateAnchor, [anchor]: open });
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const syncData = () => {
    // localStorage.setItem("isOnlineSyncAccount", 1)
    // window.location.reload();
    setActivateLoader(true)
    
    console.log(featureAccess)
    Promise.all([
      featureAccess['ACCOUNT_WISE_INVENTORY'] && getPhysicalInventoryCheckOffline(), 
      featureAccess['LOCATION_WISE_INVENTORY'] && getPreviousQuantity()]).then(res => {
      setActivateLoader(false)
      dispatch({ type: 'SYNC_COMPLETED' })
      // window.location.reload();
    }).catch(err => {
      setActivateLoader(false)
    })
  }
  const gotToNotifications = () => {
    toggleDrawer("right", true);
    navigate(`/all_notifications`);
  };

  const getListItem = (items) => {
    return items.map((text, index) => (
      <ListItem >
        <ListItemButton onClick={() => handleItemClick(text.path)}>
          <ListItemIcon>
            {text.icon == 'inventory' ? <InventoryIcon /> : text.icon == 'storage' ? <StorageIcon /> : <SyncIcon />}
          </ListItemIcon>
          <ListItemText primary={text.displayName} />
        </ListItemButton>
      </ListItem>
    ))
  }
  const addList = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleAddDrawer(anchor, false)}
      onKeyDown={toggleAddDrawer(anchor, false)}
    >
      <List>
        <ListItem color="black" sx={{ fontWeight: "bold", fontSize: 18 }}>
          <CloseIcon />
        </ListItem>
        <ListItem >
          <ListItemButton onClick={() => handleItemClick('/home')}>
            <ListItemIcon>
              <FaHome />
            </ListItemIcon>
            <ListItemText primary={"Home"} />
          </ListItemButton>
        </ListItem>
        {
          Object.keys(moduleAccess).map(mod => {
            return featureHasAccess(mod, 'VIEW', featureAccess) && <>
              <ListItem color="black" sx={{ fontWeight: "bold", fontSize: 18 }}>
                {moduleAccess[mod].displayName}
              </ListItem>
              {getListItem(moduleAccess[mod].items)}
              { }
            </>
          })
        }
      </List>
      <Divider />

    </Box>
  );

  useEffect(() => { }, []);
  const list = (anchor) => (
    <Box className="notificationPopupDiv"
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem color="black" sx={{ fontWeight: "bold", fontSize: 18 }}>
          <CloseIcon />
        </ListItem>
        {notificationData?.slice(0, 5).map((text, index) => (
          <ListItem>
            <ListItemText>
              <Grid container>
                <Grid item xs={12} md={12} className="lastitem">
                  {" "}
                  {text.textBody}
                </Grid>
              </Grid>
            </ListItemText>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem>
          <button
            className="btn seeMoreBtn"
            onClick={() => gotToNotifications()}
          >
            {metaDataConstants.moreNotifications}
          </button>
        </ListItem>
      </List>
    </Box>
  );

  const handleItemClick = (item) => {
    navigate(item);
  };



  const [isTimedOut, setIsTimedOut] = useState(false);

  const handleOnAction = (e) => {
    setIsTimedOut(false);
  };

  const handleOnActive = (e) => {
    setIsTimedOut(false);
  };

  const handleOnIdle = (e) => {
    setShowModal(true);
  };

  const onStay = () => {
    setShowModal(false);
    console.log("on stay")
  }
  return (
    <div>
      <AppBar className="headerDiv" id="header">
        <div className="row">
          <IdleTimer
            crossTab={true}
            ref={(ref) => {
              idleTimer = ref;
            }}
            element={document}
            onActive={handleOnActive}
            onIdle={handleOnIdle}
            onAction={handleOnAction}
            debounce={250}
            timeout={1000 * 30 * 60}
          />
          <ModalPopup
            show={showModal}
            onHide={() => setShowModal(false)}
            size={"sm"}
            centered={true}
            modelHeader={metaDataConstants.youAreAway}
            modelContent={

              <div className="footerButtons">
                <p>{metaDataConstants.stayOrLogout}</p>
                <Button
                  className="btn-black btn Ripple-parent btn btn-primary"
                  onClick={onStay}
                >
                  {metaDataConstants.stay}
                </Button>
                &nbsp;
                <Button
                  className="cancelBtn btn Ripple-parent btn btn-primary"
                  onClick={() => {
                    setShowModal(false);
                    idleTimer.reset();
                    setIsTimedOut(true);
                    signOut();
                  }}
                >
                  {metaDataConstants.logout}
                </Button>
              </div>
            }
            backdrop={"static"}
          />
          <ModalPopup
            show={showAppVersionModal}
            onHide={() => setShowAppVersionModal(false)}
            size={"sm"}
            centered={true}
            modelHeader={""}
            modelContent={
              <div className="footerButtons">
                <p>
                  {metaDataConstants.newVersion}
                </p>
                <p>{metaDataConstants.loginAgain}</p>
                <Button
                  className="btn-black btn Ripple-parent btn btn-primary"
                  onClick={() => {
                    clearCache();
                  }}
                >
                  {metaDataConstants.update}
                </Button>
              </div>
            }
            backdrop={"static"}
          />
          <div className="col-md-4 col-4">
            <IconButton
              className="drawerIcon"
              sx={{
                display: { xs: "flex", md: "flex" },
                backgroundColor: "none",
              }}
              size="small"
              aria-label="show 17 new notifications"
              onClick={toggleAddDrawer("left", true)}>
              < MenuIcon />
            </IconButton>
          </div>
          <div className="col-md-8 col-8">
            <ul className={"nav-menu"}>
              {isOnline && <li>
                <Tooltip title='Sync Offline Data'>
                  <IconButton
                    className="notifiDiv"
                    sx={{
                      display: { xs: "flex", md: "flex" },
                      backgroundColor: "none",
                      color: "white"
                    }}
                    size="small"
                    onClick={syncData}

                  ><CloudSyncIcon />
                  </IconButton>
                </Tooltip>
              </li>}
              <li>
                <IconButton
                  className="notifiDiv"
                  sx={{
                    display: { xs: "flex", md: "flex" },
                    backgroundColor: "none",
                  }}
                  size="small"
                  aria-label="show 17 new notifications"
                  onClick={toggleDrawer("right", true)}
                >
                  <Badge
                    badgeContent={
                      notificationCount
                    }
                    color="error"
                  >
                    <NotificationsIcon style={{ color: "#fff" }} />
                  </Badge>
                </IconButton>
              </li>
              <li>
                <div className="dropdown">
                  <button className="dropbtn">
                    <AccountCircleIcon /> <ArrowDropDownIcon />
                  </button>
                  <div className="dropdown-content">
                    <a>
                      <Avatar src={"./test"} />
                      {userName}
                    </a>
                    <a>
                      <PersonRoundedIcon />
                      {userEmail}
                    </a>
                    <a onClick={signOut}>
                      <ExitToAppIcon />
                      {metaDataConstants.signOut}
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div> {["left"].map((anchor) => (
            <React.Fragment key={anchor}>
              <SwipeableDrawer
                anchor={anchor}
                open={stateAnchor[anchor]}
                onClose={toggleAddDrawer(anchor, false)}
                onOpen={toggleAddDrawer(anchor, true)}
              >
                {addList(anchor)}
              </SwipeableDrawer>
            </React.Fragment>
          ))}</div>
          <div>
            {["right"].map((anchor) => (
              <React.Fragment key={anchor}>
                <SwipeableDrawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                  onOpen={toggleDrawer(anchor, true)}
                >
                  {list(anchor)}
                </SwipeableDrawer>
              </React.Fragment>
            ))}
          </div>
        </div>
      </AppBar>
      <Loader active={activateLoader} />

    </div>
  );
};

export default withRouter(Header);